import React, { useState, useEffect } from 'react'
import WalletDashboard from '../sections/walletDashboard'
import QrCode from '../sections/qrCode'
import TicketSupport from '../sections/ticketSupport'
import RecentActivity from '../sections/recentActivity'
import PopupModal from '../components/popupModel'
import { useNavigate } from 'react-router-dom'
import logo from '../assets/images/logo.png'

const Home = () => {
    const navigate = useNavigate();
    const [isModalOpen, setIsModalOpen] = useState(false);

    const today = new Date();
    const formattedStartDate = today.toLocaleDateString('en-IN', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
    });

    const futureDate = new Date(today);
    futureDate.setMonth(futureDate.getMonth() + 3);
    const formattedEndDate = futureDate.toLocaleDateString('en-IN', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
    });

    useEffect(() => {
        setIsModalOpen(true);
    }, []);

    return (
        <div className="relative bg-[#F5F7FF] min-h-screen p-4 md:p-8">
            {/* Blur Background when Modal is open */}
            <div className={`max-w-[1600px] mx-auto ${isModalOpen ? 'blur-sm pointer-events-none' : ''}`}>
               //<WalletDashboard />
                {/* //<QrCode />
                //<TicketSupport />
                <RecentActivity />*/}
            </div>

            {isModalOpen && (
                <PopupModal isOpen={true} setIsOpen={() => { }} popupFor="SUSPENSION!!" size="small">
                    <div className="bg-yellow-100 text-blue-900 shadow-lg shadow-blue-500 rounded-lg p-6 sm:p-10">
                        <div className="flex flex-col items-center gap-4">
                            <img
                                onClick={() => navigate('/')}
                                src={logo}
                                className="h-12 sm:h-[60px] cursor-pointer"
                                alt="MoneyLions Logo"
                            />
                            <h2 className="text-2xl sm:text-3xl font-bold text-center">IMPORTANT NOTICE</h2>
                        </div>

                        <div className="mt-6 text-base sm:text-lg leading-relaxed text-gray-800 text-justify">
                            <p><strong>Website Temporarily Suspended</strong></p>
                            <p className="mt-4">
                                This website has been temporarily suspended by the Government of India in accordance with regulatory directives.
                            </p>
                            <p className="mt-2">
                                Effective from <strong>{formattedStartDate}</strong>, the suspension will remain in place for a period of three months, until <strong>{formattedEndDate}</strong>.
                            </p>
                            <p className="mt-2">
                                We are fully cooperating with the authorities and are working diligently to resolve the matter. We appreciate your patience and understanding during this time.
                            </p>
                            <p className="mt-2">
                                For any urgent concerns or official communication, please reach out to us at <strong>info.contact@moneylions.com</strong>.
                            </p>
                            <p className="mt-2">
                                We sincerely apologize for the inconvenience.
                            </p>
                            <p className="mt-2">
                                Thank you for your continued support.
                            </p>
                        </div>
                    </div>
                </PopupModal>
            )}
        </div>
    );
};

export default Home;
